module.exports = __webpack_public_path__ + "img/shop-by-style-filter-honda.c25b24d5.png";